/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, func } from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';

import { createUrl } from 'utils/urlHelper';

import { SIGNUP_STATUS } from 'reducers/user';

import { showLoginModal as showLoginModalAction } from 'actions/login';

import SectionBlocks from 'components/SectionBlocks/SectionBlocks';

import Hero from './Hero/Hero';

import styles from './home.scss';

/**
 * This is the Home component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class Home extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    match: object.isRequired,
    history: object.isRequired,
    user: object.isRequired,
    app: shape({
      locale: string.isRequired,
    }).isRequired,
    bootstrap: shape({
      languages: object.isRequired,
      startpage: object.isRequired,
    }).isRequired,
    login: object.isRequired,
    showLoginModal: func.isRequired,
  };

  componentDidMount() {
    const {
      history: { location },
      login,
      showLoginModal,
    } = this.props;
    const isLogin = location.pathname.includes('login');

    if (isLogin && !login.showModal) {
      showLoginModal();
    }
  }

  /**
   * Render Home.
   *
   * @return {Object}
   */
  render() {
    const {
      user,
      bootstrap: {
        languages,
        startpage: { hero, sections },
      },
    } = this.props;

    const isApproved = user.status === SIGNUP_STATUS.APPLICATION_APPROVED;

    if (isApproved) {
      if (user.is_client) {
        return <Redirect to={createUrl('talents')} />;
      }

      return <Redirect to={createUrl('account')} />;
    }

    return (
      <article className={styles.frame}>
        <Helmet defer={false}>
          <link
            rel="alternate"
            href="https://ksting.com/en/"
            hrefLang="x-default"
          />

          {languages &&
            Object.keys(languages).map(lang => (
              <link
                rel="alternate"
                href={`https://ksting.com/${lang}/`}
                hrefLang={lang}
                key={lang}
              />
            ))}
        </Helmet>

        {hero && <Hero {...hero} />}

        <div className={styles.container}>
          <div className={styles.row}>
            <SectionBlocks sections={sections} />
          </div>
        </div>
      </article>
    );
  }
}

export default withRouter(
  connect(
    ({ app, bootstrap, user, login }) => ({ app, bootstrap, user, login }),
    {
      showLoginModal: showLoginModalAction,
    }
  )(Home)
);
